import {
  computeIsConfigTable,
  computeTableProvenanceUuid,
} from 'notebook/tables/store/logic/TableContextLogic';
import {createTableStoreSelector} from 'notebook/tables/store/selectors/util/SelectorCreators';
import {TableEditableStore, TableEditableVolatileProps} from 'notebook/tables/store/TableStore';

export interface TableContextModel {
  isConfigTable: boolean;
  tableProvenanceUuid: string | null;
}

export function createTableContextSelector(
  volatilePropsSelector: (store: TableEditableStore) => TableEditableVolatileProps
): (store: TableEditableStore) => TableContextModel {
  return createTableStoreSelector(
    'tableContext',
    {
      table: (store) => volatilePropsSelector(store).table,
      editorContextIsConfig: (store) => store.editorContext.isConfig,
      fileIsConfigProp: (store) => store.stableProps.fileIsConfig,
      tableProvenanceUuid: (store) => volatilePropsSelector(store).table.provenanceUuid,
      proxyProvenanceUuid: (store) => store.stableProps.proxyProvenanceUuid,
    },
    ({table, editorContextIsConfig, fileIsConfigProp, tableProvenanceUuid, proxyProvenanceUuid}) => ({
      isConfigTable: computeIsConfigTable(table, editorContextIsConfig, fileIsConfigProp),
      tableProvenanceUuid: computeTableProvenanceUuid(tableProvenanceUuid, proxyProvenanceUuid),
    })
  );
}
